<template>
        <div class="blog-detail-wrapper" v-if="item.type==='exam'">
          <b-row>
            <!-- blogs -->
            <b-col cols="12">
              <b-card>
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-50"
                  >
                    <b-avatar
                      href="javascript:void(0)"
                      size="24"
                      :src="item.user.profile_image_path"
                    />
                  </b-media-aside>
                  <b-media-aside>
                    <h6 class="font-weight-bolder">
                     {{item.name}}
                    </h6>
                  </b-media-aside>
                  <b-media-body>
                    <small class="text-muted mr-50">by</small>
                    <small>
                      <b-link class="text-body">{{item.user.full_name}}</b-link>
                    </small>
                    <span class="text-muted ml-75 mr-50">|</span>
                    <small class="text-muted">{{item.created_at}}</small>
                  </b-media-body>
                </b-media>
              </b-card>
            </b-col>
            <!--/ blogs -->
            <!-- datatable -->
              <div class="col-md-12  overflow-auto">
                <b-table :stacked="($mobile==1)" 
                  ref="table"
                  class="vuetable"
                  sort-by="id"
                  sort-desc.sync="false"
                  :fields="bootstrapTable.fields"
                  :items="dataProvider"
                >
                  <template #cell(answers)="data">
                    <b-button
                      v-b-modal.modal-scrollable
                      variant="outline-info"
                      @click="activity_answer_modal(data.item)"
                    >
                      {{ $t("activities.show") }}
                    </b-button>
                  </template>
                  <!-- <template #cell(edit)="data">
                    <button
                      class="btn btn-icon btn-warning btn-sm"
                      @click="editAnswer(data)"
                      v-if="!data.item.grade"
                    >
                      <i class="fa fa-edit" />
                    </button>
                  </template> -->

                </b-table>
                          <b-spinner   v-if="load" type="grow" label="Loading..."  class="loading" />
                <!-- end of table -->
              </div>
              <!-- end of datatable -->
            <!-- </div> -->

            <!-- Leave a Blog Comment -->
            <b-col
              cols="12"
              class="mt-2"
              v-if="(totalAnswers < 3 && checkTime(item)) || (edit==true && checkTime(item))"
            >
              <h6 class="section-label">
                {{$t('activities.solve_your_exam')}}
              </h6>
                <b-card v-if="load==false">
                <b-card-title>
                  <b-row>
                  <b-col lg="11">
                    <h3 class="card-label" id="question">
                    {{ index + "-" + questions[index - 1].question }}
                    </h3>
                    </b-col>
                    <b-col lg="1">
                  <b-media-aside class="mr-75" >
                      <b-badge variant="success"><feather-icon icon="StarIcon" class="mr-25"/><span>{{questions.length}}/{{index}}</span></b-badge>
                  </b-media-aside>
                  </b-col>
                  </b-row>
                </b-card-title>
                <b-card-body>
                      <div class="quiz" id="quiz" data-toggle="buttons">
                            <b-row>
                            <b-col lg="6" v-for="(item,i) in questions[index - 1].answers" :key="i">
                                <b-button
                                :variant="questions[index - 1].answer_id==item.id ?'info':variant"
                                @click="answer(questions[index - 1],item)"
                               
                                class="element-animation1 btn-block answer"
                                pill
                                >
                                    {{ item.answer }}</b-button
                                >

                                </b-col
                            >
                            </b-row>
                        </div>
                </b-card-body>
                <b-card-footer class="d-flex justify-content-between">
                    <b-button
                    variant="relief-primary"
                    class="col-4"
                    v-if="index != 1"
                    @click="index--"
                    >سابق</b-button
                    >
                    <b-button
                    variant="relief-info"
                    class="col-4"
                    v-if="questions.length > index"
                    @click="index++"
                    >التالي</b-button
                    >
                    <b-button
                    variant="relief-success"
                    class="col-4"
                    :disabled="isDisabled"
                    v-if="questions.length == index"
                     @click="submit()"
                    >انتهى</b-button
                    >
                </b-card-footer>
                </b-card>
                <b-spinner   v-if="load" type="grow" label="Loading..."  class="loading" />

            </b-col>
            <!--/ Leave a Blog Comment -->
          </b-row>
          <!--/ blogs -->

    <b-modal
      id="modal-scrollable"
      scrollable
      :title="$t('activities.questions')"
      ok-only
      :ok-title="$t('activities.done')"
      size="lg"
    >
          <b-row >
            <b-col lg="12">
              <b-form v-for="(q,k) in  questions_with_answers" :key="k">
                <b-row  >
                  <b-col lg="2" >
                      <label>{{$t('activities.question')}} {{k+1}}</label>
                  </b-col>
                  <b-col lg="10"> 
                          <b-form-input
                            type="text"
                            :value="q.question"
                            disabled
                          /> 
                  </b-col>
                </b-row>
                <br />
                <b-row v-for="(answer,ke) in  q.answers" :key="ke">
                    <b-col lg="6">
                          <b-form-input
                            type="text"
                            :value="answer.answer"
                            disabled
                          /> 
                    </b-col>
                    <b-col lg="2">
                      <b-form-radio
                        v-model="selected"
                        name="answer"
                        :value="(q.answer_id===answer.id )?1:0"
                        :class="(q.answer_id===answer.id && answer.type===0)?'custom-control-danger':'custom-control-success'"
                        disabled
                      >
                      </b-form-radio> 
                    </b-col>
                </b-row>
                <hr />
              </b-form>
            </b-col>
          </b-row>
    </b-modal>
        </div>

</template>

<script>
import Ripple from 'vue-ripple-directive';
import ActivitiesController from '@/Controllers/ActivitiesController';
import Auth from "@/Apis/Auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    },
  data() {
    return {
      file: {},
      variant: "outline-info",
      bootstrapTable: {
        selected: [],
        selectMode: 'multi',
        fields: [
          {
            key: 'grade', label: this.$i18n.t('activities.grade'), sortable: true, sortDirection: 'desc',
          },
          {
            key: 'answers', label: this.$i18n.t('activities.answers'), sortable: true, sortDirection: 'desc',
          },
        ],
      },
      // newAnswer:{},
      questions_with_answers:[],
      questions:[],
      user:{},
      load: false,
      totalAnswers:0,
      data: {},
      edit:false,
      index:1,
      isDisabled:false,
      selected:'1',
    }
  },
  directives: {
    Ripple,
    },
  async created(){
    this.user = Auth.USER;
    await this.getQuestions();
    // this.prepare_questions();
  },
  methods:{
    checkTime(item) {
      const check = new Date();
      console.log(item.start_date);

      const stDate = new Date(item.start_date);
      const enDate = new Date(item.end_date);
      console.log(stDate,enDate)
      if (
        check.getTime() <= enDate.getTime() &&
        check.getTime() >= stDate.getTime()
      )
        return true;
      // && datanow <= enDate) return true;
      return false;
    },
    async getQuestions(){
      this.questions=[];
        this.load=true;
        const data = await new ActivitiesController().GetAll({'activity_id':this.$props.item.id,with:'questions'});
        data[0].questions.forEach((el)=>{
            this.questions.push({
                question:el.question,
                activity_question_id:el.id,
                answers:el.answers,
                answer_id:'',
                user_id:this.user.id,
            });
        })
        this.load=false;
    },
    answer(question,answer){
        const bocket=this.questions.map(obj => {
            if (obj.activity_question_id === question.activity_question_id) {
                return {...obj, answer_id: answer.id};
            }
            return obj;
        });
        this.questions=bocket;
    },
    activity_answer_modal(item){
      this.questions_with_answers=item.questions;
      console.log(this.questions_with_answers);
    },
    // prepare_questions(){
    //   this.questions=[];
    //       this.$props.item.questions.map((el)=>{
    //         this.questions.push({
    //           question:el.question,
    //           activity_question_id:el.id,
    //           answer:'',
    //           user_id:this.user.id,
    //         });
    //       })
    // },
    // editAnswer(data){
    //   this.edit=true;
    //   window.scrollTo(0, 500);
    //   this.questions=data.item.questions;
    //   console.log(this.questions);

    // },
    async dataProvider() {
      this.load = true
      let questions_ids=this.$props.item.questions.map((el)=>{
        return el.id;
      });
      const data = await new ActivitiesController().GetHomeWorkAnswers({with:'question',questions_ids:questions_ids})
      console.log(data);
      this.data = this.handleDataTableData(data);
      this.load = false
      return this.data;
    },
    handleDataTableData(data){
      let res=[];
      for(let i=1;i<=3;i++){
        let correct_flag=0;
        let mygrade=0;
        const results=data.filter((element)=>{
            return element.answer_number==i;
        });
        if(results.length>0){
        let questions=[];
        results.map((el)=>{
            if(el.grade!=null){
              correct_flag=1;
              mygrade+=el.grade;
            }
            questions.push({
              id:el.id,
              question:el.question.question,
              activity_question_id:el.activity_question_id,
              grade:el.grade,
              answers:el.question.answers,
              answer_id:el.answer_id,
              user_id:this.user.id,
              answer_number:el.answer_number
            })
        })
        res.push({
          grade:correct_flag==0?null:((mygrade/results.length)*(this.$props.item.grade/100)).toFixed(2),
          questions:questions,
        })
        }
      }
      // console.log(res);
      this.totalAnswers=res.length;
      return res;
    },
    async submit(){
      this.isDisabled=true;
      // this.dataHandle()
      // console.log(this.dataHandle());
      let ret = await new ActivitiesController().activity_answer(this.dataHandle());
      if(ret){
        this.load=true;
        await this.dataProvider();
        window.scrollTo(500,0);
        this.$refs.table.refresh();
        this.edit=false;
        this.getQuestions();
        // console.log(this.$props.item.questions);
        this.load=false;
        this.isDisabled=false;
        this.index=1;
      }
    },
    dataHandle(){
      let data=[];
      if(this.edit==false){
        this.questions.forEach((element) => {
          element.answer_number = this.totalAnswers+1
          element.grade=this.question_correction(element.answer_id,element.answers);
          delete element['question'];
          delete element['answers'];
        });
      }else{
        this.questions.forEach((element) => {
          element.grade=this.question_correction(element.answer_id,element.answers);
          delete element['question'];
          delete element['answers'];
        });
      }
      data=this.questions;
      
      return {data:data,edit:this.edit,user:this.user,activity:this.$props.item};
        
    },
    question_correction(selected_id,answers){
      let grade = 0;
      answers.forEach((el)=>{
        if(el.id===selected_id){
          if(el.type===1){
            grade= 100;
          }
        }
      });
      return grade;
    },

  },

}
</script>
<style>

</style>